import PropTypes from 'prop-types';
import React from 'react';

class PopRender extends React.Component {
  constructor(props){
    super(props)
    this.getState = this.getState.bind(this)
  }
  componentWillMount(){
    if (this.props.isOpen)
      this.context.open(this.getState(this.props))
  }
  componentWillReceiveProps(nextProps){
    if (nextProps.isOpen && !this.props.isOpen){
      this.context.open(this.getState(nextProps))
    } else if (!nextProps.isOpen && this.props.isOpen){
      this.context.close()
    } else if (nextProps.isOpen && this.props.isOpen && nextProps.children !== this.props.children){
      this.context.open(this.getState(nextProps))
    }
  }
  componentWillUnmount(){
    this.context.close()
  }
  getState(props){
    return {
      onClose: props.onClose,
      content: props.children,
      className: props.className,
      title: props.title,
      style: props.style,
    }
  }
  render(){
    return null
  }
}

PopRender.contextTypes = {
  open: PropTypes.func,
  close: PropTypes.func,
}

PopRender.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default PopRender



/** WEBPACK FOOTER **
 ** ./client/components/blueprint/PopRender.js
 **/